<template>
  <div>
    <div class="sm:flex justify-center">
      <div
        class="
          my-10
          flex justify-center
          md:w-full
          sm:pt-10
        "
        v-for="(item, x) in buttonLabels"
        :key="x"
      >
        <MenuButton
          @onPress="to(item)"
          :label="item.menu_name"
          :src="item.icon"
        />
      </div>
    </div>
    <v-snackbar v-model="snackbar" top>
      {{ snackbarText }}
      <v-btn text @click.native="value = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import MenuButton from "../../common/MenuButton.vue";

export default {
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      dialog: false,
      buttonLabels: [
        {
          id: 1,
          menu_name: "Submit a Request",
          icon: require("../../assets/icons/submit-request.png"),
          name: "submit-request",
        },
        {
          id: 2,
          menu_name: "Submit an Inquiry",
          icon: require("../../assets/icons/submit-inquiry.png"),
          name: "submit-inquiry",
        },
      ],
    };
  },
  components: { MenuButton },
  methods: {
    to() {
      this.snackbar = true;
      this.snackbarText = "Under construction";
      // if (item.id == 1) {
      //   this.$router.push({
      //     name: item.name,
      //     params: {
      //       customer_id: this.$route.customer_id,
      //       contract_number: this.$route.contract_number,
      //     },
      //   });
      // } else {
      //   alert("Under construction");
      // }
    },
  },
};
</script>
